import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import { setPublicationsMetadata } from "src/redux";
import { ToolbarListWrapper } from "../ToolbatListWrapper/ToolbarListWrapper";
import ToolbarList from "../ToolbarList/ToolbarList";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ToolbarListItem } from "../ToolbarListItem/ToolbarListItem";
import { sortGridElementsByLabel } from "../../functions/sortGridElementsByName";

export function ToolbarListPublicationMetaFields({
  format,
  toolbarListProps,
  campaignId,
}) {
  const {
    reportReducer: {
      campaigns,
      gridElements,
      hiddenGridElements,
      publicationsMetadata,
      summaryStatistics,
    },
  } = useSelector((state) => state);

  const { publicationsSummary } = campaigns[campaignId] || {};

  const allElements = [...gridElements, ...hiddenGridElements];

  const publications = allElements
    .filter(
      (item) =>
        item.gridBoxType === "publication" && item.campaignId === campaignId,
    )
    .map((item) => ({
      label: item.title,
      value: item.label,
      campaignId: item.campaignId,
    }))
    .sort((a, b) => sortGridElementsByLabel(a, b));

  const metadata = publicationsMetadata[campaignId] || [];

  const dispatch = useDispatch();

  const publicationProviders = useMemo(
    () =>
      Object.keys(publicationsSummary || {})?.map((provider) => ({
        provider: `publication-summary-${provider}`,
        disableExpanding: !publicationsSummary[provider]?.summary?.length,
      })) || [],
    [publicationsSummary, summaryStatistics],
  );

  const toggleFieldVisibility = (newValue, uuid) => {
    const newPublicationsMetadata = metadata?.map((item) => {
      if (item.uuid === uuid) {
        return {
          ...item,
          reportVisible: newValue,
        };
      }
      return item;
    });

    dispatch(setPublicationsMetadata(campaignId, newPublicationsMetadata));
  };

  return (
    <div>
      <div className="toolbar-list__list-item">
        <IDHFormattedMessage
          id="ws_publications"
          defaultMessage="Publications"
        />
      </div>
      {publications?.map((item) => (
        <ToolbarListItem
          key={item.value}
          item={item}
          provider="publication"
          format={format}
          toolbarListProps={toolbarListProps}
          isReport
        />
      ))}

      <div className="toolbar-list__list-item">
        <IDHFormattedMessage id="ws_attributes" defaultMessage="Attributes" />
      </div>
      {metadata?.map((item) => {
        return (
          <div className="toolbar-list__list-item">
            <CustomCheckbox
              id={item.uuid}
              checked={item.reportVisible}
              onChange={() =>
                toggleFieldVisibility(!item.reportVisible, item.uuid)
              }
            />
            {item.name}
          </div>
        );
      })}

      {publicationProviders?.map((item, index) => (
        <ToolbarListWrapper key={item.provider} loading={false}>
          <ToolbarList
            provider={item.provider}
            format={format.value}
            open={item.open}
            toolbarListProps={toolbarListProps}
            disableExpanding={item.disableExpanding}
            noBottomBorder={index === publicationProviders.length - 1}
            isReport
            hideCheckbox
            campaignId={campaignId}
          />
        </ToolbarListWrapper>
      ))}
    </div>
  );
}
